import React from 'react';
import { SelectPicker as RSSelectPicker, SelectPickerProps as RSSelectPickerProps } from 'rsuite5';
import { FieldProps } from 'formik';

export interface SelectPickerProps extends Omit<RSSelectPickerProps<any>, 'form'>, FieldProps {}

export default function SelectPicker({ field, form, ...props }: SelectPickerProps) {
  return (
    <RSSelectPicker
      name={field.name}
      value={field.value}
      onChange={(value, event) => {
        form.setFieldValue(field.name, value);
        field.onChange(event);
      }}
      {...props}
    />
  );
}
